<style src="./style/general.scss" lang="scss"></style>
<template>
  <div id="app">
    <router-view name="mainMenu" />
    <router-view class="content"/>

    <div class=""
      v-shortkey="['ctrl', 'l']"
      @shortkey="enterSuspendMode()">
      <relogin />
    </div>
    <div>
    </div>
    <div
      v-if="showFileModal"
      class="documentmodal"
      @click="closeDocumentModal">
      <div
        v-shortkey="['esc']"
        @shortkey="closeDocumentModal"
        class="documentview"
        ref="previewpdf">
      </div>
    </div>
  </div>
</template>

<script>
import Relogin from '@/components/foundation/relogin/Relogin'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {
    Relogin
  },
  computed: {
    ...mapGetters({
      showFileModal: 'EventDocuments/SHOW_PDF_DOCUMENT'
    })
  },
  methods: {
    enterSuspendMode () {
      const appExpired = this.$store.getters['Login/GET_EXPIRE_STATUS']
      if (appExpired === 'NO') this.$store.dispatch('Login/FORCE_EXPIRE', { expireStatus: 'BYUSER' })
    },
    closeDocumentModal () {
      this.$store.commit('EventDocuments/SHOW_PDF_DOCUMENT', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue